
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-7c372f96&scoped=true!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./MyVoiceTag.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MyVoiceTag.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-7c372f96!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MyVoiceTag.vue"),
  /* scopeId */
  "data-v-7c372f96",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/anchor/center/MyVoiceTag.vue
// module id = 407
// module chunks = 0